import styled from "styled-components";
import { NoAccountsFilled } from "@assets";

export const RootContainer = styled.div`
	padding: 16px;

	@media screen and (max-width: 350px) {
		padding: 16px 8px;
	}
`;

export const ItemBox = styled.div`
	padding: 0 10px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	border-radius: 8px;
	border: 1px solid #E5E0F5;
	cursor: pointer;
	background-color: #F8EEFF;
	margin-bottom: 16px;

	.ant-divider {
		top: 0 !important;
		height: 80px !important;
		margin-inline: 0 !important;
		border-inline-start: 1px solid #E5E0F5 !important;
	}
`;

export const InfoBox = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: start;
	gap: 1px;
`;

export const ButtonWrapper = styled.div`
	margin: 32px 0 16px 0;
	width: 100%;
	text-align: center;
	display: flex;
	justify-content: center;

	.ant-btn-primary {
		width: ${(props) =>
			props.fullWidth === "true" ? "100%" : "auto"} !important;
		height: 55px;
		padding-inline: 24px;
		display: flex;
		gap: 6px;
		justify-content: center;
		align-items: center;
		flex-direction: row-reverse;

		span {
			font-size: 16px;
			color: #fff;
			font-weight: 500;
		}
	}

	.ant-btn-icon {
		font-size: 24px;
		margin: 0 !important;
	}
`;

export const SpinWrapper = styled.div`
	height: calc(100vh - 70px);
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Image = styled.img.attrs({
	alt: "img",
})`
	width: 54px;
	border-radius: ${(props) => (props.radius === "none" ? "none" : "12px")};
	object-fit: contain;

	@media screen and (max-width: 378px) {
		width: 40px;
	}
`;

export const Title = styled.div`
padding: 4px 12px;
margin-bottom: 16px;
border-radius: 8px;
background-color: #F8EEFF;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #49028E;
`;

export const NumberText = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	color: #000;

	@media screen and (max-width: 378px) {
		font-size: 13px;
	}
`;

export const Text = styled.div`
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #5D5189;
`;

export const EmptyBox = styled.div`
	margin-top: 25%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;

	@media screen and (min-height: 800px) {
		margin-top: 35%;
	}

	@media screen and (min-height: 900px) {
		margin-top: 40%;
	}
`;

export const EmptyIcon = styled(NoAccountsFilled)`
	width: 120px;
	height: 120px;

	@media screen and (max-width: 375px) {
		width: 100px;
		height: 100px;
	}
`;

export const EmptyText = styled.div`
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	color: #949393;
	margin-bottom: 24px;
`;
